import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    const initialQuery = this.getQueryParam("q") || "";
    if (initialQuery) {
      this.inputTarget.value = initialQuery;
      this.applyFilter(initialQuery);
    }
  }

  getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  updateQueryParam(query) {
    const url = new URL(window.location);
    if (query) {
      url.searchParams.set("q", query);
    } else {
      url.searchParams.delete("q");
    }
    window.history.replaceState({}, "", url);
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim();
    this.updateQueryParam(query);
    this.applyFilter(query);
  }

  applyFilter(query) {
    // Query for items in the document (since search is in nav, items are in page body)
    const items = document.querySelectorAll("[data-search-item]");

    items.forEach((item) => {
      const name = item.dataset.name || "";
      const matches = query === "" || name.toLowerCase().includes(query);
      item.style.display = matches ? "" : "none";
    });
  }
}
